import { useEffect } from 'react';

/**
 * Sets the document title when the component mounts.
 *
 * @param title - The title to set for the document
 * @param enabled - Whether to apply the title (defaults to true).
 *                  Set to false when rendering a component inside a modal
 *                  to prevent it from overriding the parent page's title.
 */
const useDocumentTitle = (title: string, enabled: boolean = true) => {
  useEffect(() => {
    if (!enabled) return;

    document.title = title;
  }, [title, enabled]);
};

export default useDocumentTitle;
